import { I18n } from 'app/components/localization';
import GetDisplayName from 'app/components/users/GetDisplayName';
import { LessonStudent, LessonTeacher } from 'app/constants/schemas';
import EntityField from 'app/containers/entities/EntityField';
import GetEntity from 'app/containers/entities/GetEntity';
import { BookingStateConsumer } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingType } from 'app/models/rtc/booking/constants';
import React, { FunctionComponent } from 'react';
import LessonBookingRole from 'app/constants/LessonBookingRole';

/**
 * Also used to set the page title during a lesson.
 */
export const GetLessonBookingGreetingString: FunctionComponent<{
  children: (greeting: string | null) => React.ReactNode,
}> = ({ children }) => (
  <I18n>{({ t, formatDate }) => (
    <BookingStateConsumer>{(bookingState) => {
      if (!bookingState || bookingState.bookingType !== BookingType.Lesson) {
        return children(null);
      }

      const date = formatDate(bookingState.time.start, 'llll');

      if (bookingState.lessonRole === LessonBookingRole.Teacher) {
        return (
          <GetEntity id={bookingState.studentId} type={LessonStudent}>{lessonStudent =>
            <GetDisplayName>{getDisplayName =>
              children(t('booking.lesson-greeting', { date, name: getDisplayName(lessonStudent) }))
            }</GetDisplayName>
          }</GetEntity>
        );
      }

      if (bookingState.lessonRole === LessonBookingRole.Student) {
        return (
          <EntityField
            id={bookingState.teacherId}
            field="name"
            type={LessonTeacher}
          >{({ value: name }) => (
            children(t('booking.lesson-greeting', { date, name }))
          )}
          </EntityField>
        );
      }

      // Don't show anything if the user is not a teacher or student.
      return children(null);
    }}</BookingStateConsumer>
  )}</I18n>
);
